export default [{ 
    "poollid": 1026, 
    "unitlid": 1016, 
    "objectId": 17, 
    "objectName": "Gusjöbyns stugby 218", 
    "arrdate": "2021-02-27", 
    "depdate": "2021-03-06", 
    "pricecode": "L", 
    "currency": "SEK", 
    "promotionlid": -1, 
    "price": "9720", 
    "addons": [
        { 
            "extraspoollid": 1135, 
            "show_web": "T", 
            "mandatory_web": "T", 
            "default_web": "F", 
            "demand_web": "F", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 1, 
            "max_qty": 1, 
            "type_input": "Checkbox", 
            "resvtypelid": 1001, 
            "extraslid": 1737, 
            "desc1": "L6-8V", 
            "desc2": "Skipass 6-8 dagars vuxen", 
            "arttext": "Skipass 6-8 dagars vuxen", 
            "fromdate": "2021-02-27 00:00:00", 
            "todate": "2021-03-06 00:00:00", 
            "pricecode": "SKIO1068DG", 
            "aprice": "1760", 
            "curraprice": "1760", 
            "currency": "SEK", 
            "qty": 2, 
            "days": 7, 
            "auto": "T", 
            "ownerpricecode": "", 
            "lid": 1135, 
            "longdescription": "" 
        }, {
            "extraspoollid": 1113, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "T", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 1, 
            "type_input": "Radiobutton", 
            "resvtypelid": 1000, 
            "extraslid": 1013, 
            "desc1": "Z60-69", 
            "desc2": "Avresestäd 60-69 kvm", 
            "arttext": "Avresestäd", 
            "fromdate": "2021-03-06 00:00:00", 
            "todate": "2021-03-07 00:00:00", 
            "pricecode": "STA", 
            "aprice": "1750", 
            "curraprice": "1750", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 1, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1113, 
            "longdescription": "Vid köpt avresestädning sker avresa vid kl. 10.00\r\nInför er avresa ska ni diska, torka glas och porslin och ställa in det i köksskåpen på rätt plats, diskmaskinen kan lämnas igång. Tömma kyl och frys. Vik ihop täckena och lägg dem ihopvikta på sängarna.\r\nTa med soporna och kasta på avfallsstationen.  " 
        },
        { 
            "extraspoollid": 1119, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "F", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 5, 
            "type_input": "Dropdown", 
            "resvtypelid": 1000, 
            "extraslid": 1022, 
            "desc1": "ZBARNSTOL", 
            "desc2": "Barnstol", 
            "arttext": "Barnstol", 
            "fromdate": "2021-02-27 00:00:00", 
            "todate": "2021-03-06 00:00:00", 
            "pricecode": "STA", 
            "aprice": "150", 
            "curraprice": "150", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 7, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1119, 
            "longdescription": "Levereras fram till kl 17.00 på ankomstdagen, om er barnstol ej levererats före kl 17.00, vänligen kontakta receptionen. tel 0046 (0) 280-96200." 
        },
        { 
            "extraspoollid": 1118, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "F", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 5, 
            "type_input": "Dropdown", 
            "resvtypelid": 1000, 
            "extraslid": 1023, 
            "desc1": "ZBARNSÄNG", 
            "desc2": "Barnsäng", 
            "arttext": "Barnsäng", 
            "fromdate": "2021-02-27 00:00:00", 
            "todate": "2021-03-06 00:00:00", 
            "pricecode": "STA", 
            "aprice": "195", 
            "curraprice": "195", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 7, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1118, 
            "longdescription": "Resesäng som levereras fram till kl 17.00 på ankomstdagen, om er barnsäng ej levererats före kl 17.00, vänligen kontakta receptionen, tel 0046 (0) 280-96200. Obs! medtag eget täcke och kudde." 
        }, 
        { 
            "extraspoollid": 1120, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "F", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 17, 
            "type_input": "Dropdown", 
            "resvtypelid": 1000, 
            "extraslid": 1024, 
            "desc1": "ZLINNE", 
            "desc2": "Linneset   badlakan, handduk", 
            "arttext": "Linneset", 
            "fromdate": "2021-02-27 00:00:00", 
            "todate": "2021-03-06 00:00:00", 
            "pricecode": "STA", 
            "aprice": "195", 
            "curraprice": "195", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 7, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1120, 
            "longdescription": "Hyr ditt linneset av oss istället för att ta med det hemifrån! \r\nI linnesetet ingår sängkläder samt stor och liten frottéhandduk. Linnesetet levereras fram till kl 17.00 på ankomstdagen, om ert linneset ej levererats före kl 17.00, vänligen kontakta receptionen, tel 0046 (0) 280-96200. Inför avresa är vi tacksamma för att ni bäddar ur sängarna och lämnar linneseten i hallen i ert boende. " 
        }, 
        { 
            "extraspoollid": 1, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "F", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 1, 
            "type_input": "Checkbox", 
            "resvtypelid": 0, 
            "extraslid": 1002, 
            "desc1": "AVB", 
            "desc2": "Avbeställningsskydd", 
            "arttext": "Avbeställningsskydd", 
            "fromdate": "2021-02-27 00:00:00", 
            "todate": "2021-02-28 00:00:00", 
            "pricecode": "STA", 
            "aprice": "395", 
            "curraprice": "395", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 1, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1, 
            "longdescription": "Fram till och med 31 augusti bjuder vi även på om- och avbeställningsskydd, värde 395 SEK. \r\n\r\nVårt sätt att resa har tagit lite annorlunda former i och med Covid-19. Vi följer Folkhälsomyndighetens rekommendationer och vill så klart bidra till att du tryggt och flexibelt kan justera dina resplaner. Om Folkhälsomyndigheten eller andra myndigheter avråder för resor som inte är nödvändiga, har du som gäst rätt att om- eller avboka din vistelse på Kläppen. Du kan om- eller avboka fram till dagen före ankomst.  \r\n\r\n Vid ombokning till en dyrare period betalar du mellanskillnaden, vid ombokning till ett lägre pris, återbetalas mellanskillnaden till dig. Du kan boka om till både sommarsäsongen 2021 och vintersäsongen 20212022.? När du köper vårt om- och avbeställningsskydd kan du fritt omboka fram till dess att det är 60 dagar kvar till ankomst. Vid ombokning till en dyrare period betalas mellanskillnaden av dig, vid ombokning till ett lägre pris återbetalas mellanskillnaden till dig. Du behöver inte ange någon orsak eller lämna något intyg. Ombokning är ej möjlig när det är 59 dagar kvar eller mindre till ankomst.\r\n\r\nDu kan avboka fram till dagen före ankomst med om- och avbeställningsskyddet och återfå allt utom en avbokningsavgift på 500 SEK   det erlagda om- och avbeställningsskyddet. Avbeställningsskyddet gäller i följande fall, som inte får ha varit kända när Du bokade,\r\n\r\ndödsfall, sjukdom eller olycksfall av allvarlig art, som drabbat Dig själv, makemaka, sambo, familj eller medresenär, inkallelse till krigsmakten eller civilförsvaret, det inträffar någon allvarlig händelse utanför din kontroll, som Du inte kunde förutse när du boknade och som medför att det inte är rimligt att begära att Du ska stå fast vid din bokning, t.ex. omfattande eldsvåda eller översvämning i Din bostad.\r\n\r\nDu måste kunna styrka ditt förhinder med intyg från t.ex. läkare, myndighet, arbetsgivare eller skyddsbolag. Intyget ska vara oss tillhanda inom 14 dagar från avbokningsdagen" 
        }
    ], 
    "noofchild1": 0, 
    "noofchild2": 0, 
    "noofchild3": 1, 
    "noofchild5": 0, 
    "accommodationImages": [
        "http://static.r360online.se/klappen/images/8d3abf6456c56ba6d05f7d96702e6e7d_org.jpg", 
        "http://static.r360online.se/klappen/images/12a146e8a3e02bad2d9cb2df3994d2c8_org.jpg", 
        "http://static.r360online.se/klappen/images/1d358dc2abad7b1626df5802cf78e4f4_org.jpg", 
        "http://static.r360online.se/klappen/images/5bd61a6bdb1ab7be1f7b54956591c387_org.jpg", 
        "http://static.r360online.se/klappen/images/1862eb832a7af16a9b84b0344c0a2ad5_org.jpg", 
        "http://static.r360online.se/klappen/images/849cde80ad56c974fafb8e6fbcd9bcd7_org.jpg", 
        "http://static.r360online.se/klappen/images/f8b988f98d4a02a9d2a8354d87e684ae_org.jpg"], 
    "qty": 1 
},
{
    "poollid": 1027, 
    "unitlid": 1015, 
    "objectId": 16, 
    "objectName": "Gusjöbyns stugby 217", 
    "arrdate": "2021-02-27", 
    "depdate": "2021-03-06", 
    "pricecode": "L", 
    "currency": "SEK", 
    "promotionlid": -1, 
    "price": "11720", 
    "addons": [
        {
            "extraspoollid": 1113, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "T", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 1, 
            "type_input": "Radiobutton", 
            "resvtypelid": 1000, 
            "extraslid": 1013, 
            "desc1": "Z60-69", 
            "desc2": "Avresestäd 60-69 kvm", 
            "arttext": "Avresestäd", 
            "fromdate": "2021-03-06 00:00:00", 
            "todate": "2021-03-07 00:00:00", 
            "pricecode": "STA", 
            "aprice": "1750", 
            "curraprice": "1750", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 1, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1113, 
            "longdescription": "Vid köpt avresestädning sker avresa vid kl. 10.00\r\nInför er avresa ska ni diska, torka glas och porslin och ställa in det i köksskåpen på rätt plats, diskmaskinen kan lämnas igång. Tömma kyl och frys. Vik ihop täckena och lägg dem ihopvikta på sängarna.\r\nTa med soporna och kasta på avfallsstationen.  " 
        },
        { 
            "extraspoollid": 1119, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "F", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 5, 
            "type_input": "Dropdown", 
            "resvtypelid": 1000, 
            "extraslid": 1022, 
            "desc1": "ZBARNSTOL", 
            "desc2": "Barnstol", 
            "arttext": "Barnstol", 
            "fromdate": "2021-02-27 00:00:00", 
            "todate": "2021-03-06 00:00:00", 
            "pricecode": "STA", 
            "aprice": "150", 
            "curraprice": "150", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 7, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1119, 
            "longdescription": "Levereras fram till kl 17.00 på ankomstdagen, om er barnstol ej levererats före kl 17.00, vänligen kontakta receptionen. tel 0046 (0) 280-96200." 
        },
        { 
            "extraspoollid": 1118, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "F", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 5, 
            "type_input": "Dropdown", 
            "resvtypelid": 1000, 
            "extraslid": 1023, 
            "desc1": "ZBARNSÄNG", 
            "desc2": "Barnsäng", 
            "arttext": "Barnsäng", 
            "fromdate": "2021-02-27 00:00:00", 
            "todate": "2021-03-06 00:00:00", 
            "pricecode": "STA", 
            "aprice": "195", 
            "curraprice": "195", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 7, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1118, 
            "longdescription": "Resesäng som levereras fram till kl 17.00 på ankomstdagen, om er barnsäng ej levererats före kl 17.00, vänligen kontakta receptionen, tel 0046 (0) 280-96200. Obs! medtag eget täcke och kudde." 
        }, 
        { 
            "extraspoollid": 1120, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "F", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 17, 
            "type_input": "Dropdown", 
            "resvtypelid": 1000, 
            "extraslid": 1024, 
            "desc1": "ZLINNE", 
            "desc2": "Linneset   badlakan, handduk", 
            "arttext": "Linneset", 
            "fromdate": "2021-02-27 00:00:00", 
            "todate": "2021-03-06 00:00:00", 
            "pricecode": "STA", 
            "aprice": "195", 
            "curraprice": "195", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 7, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1120, 
            "longdescription": "Hyr ditt linneset av oss istället för att ta med det hemifrån! \r\nI linnesetet ingår sängkläder samt stor och liten frottéhandduk. Linnesetet levereras fram till kl 17.00 på ankomstdagen, om ert linneset ej levererats före kl 17.00, vänligen kontakta receptionen, tel 0046 (0) 280-96200. Inför avresa är vi tacksamma för att ni bäddar ur sängarna och lämnar linneseten i hallen i ert boende. " 
        }, 
        { 
            "extraspoollid": 1, 
            "show_web": "T", 
            "mandatory_web": "F", 
            "default_web": "F", 
            "demand_web": "F", 
            "default_internal": null, 
            "default_owner": null, 
            "demand_internal": null, 
            "demand_owner": null, 
            "min_qty": 0, 
            "max_qty": 1, 
            "type_input": "Checkbox", 
            "resvtypelid": 0, 
            "extraslid": 1002, 
            "desc1": "AVB", 
            "desc2": "Avbeställningsskydd", 
            "arttext": "Avbeställningsskydd", 
            "fromdate": "2021-02-27 00:00:00", 
            "todate": "2021-02-28 00:00:00", 
            "pricecode": "STA", 
            "aprice": "395", 
            "curraprice": "395", 
            "currency": "SEK", 
            "qty": 0, 
            "days": 1, 
            "auto": "F", 
            "ownerpricecode": "", 
            "lid": 1, 
            "longdescription": "Fram till och med 31 augusti bjuder vi även på om- och avbeställningsskydd, värde 395 SEK. \r\n\r\nVårt sätt att resa har tagit lite annorlunda former i och med Covid-19. Vi följer Folkhälsomyndighetens rekommendationer och vill så klart bidra till att du tryggt och flexibelt kan justera dina resplaner. Om Folkhälsomyndigheten eller andra myndigheter avråder för resor som inte är nödvändiga, har du som gäst rätt att om- eller avboka din vistelse på Kläppen. Du kan om- eller avboka fram till dagen före ankomst.  \r\n\r\n Vid ombokning till en dyrare period betalar du mellanskillnaden, vid ombokning till ett lägre pris, återbetalas mellanskillnaden till dig. Du kan boka om till både sommarsäsongen 2021 och vintersäsongen 20212022.? När du köper vårt om- och avbeställningsskydd kan du fritt omboka fram till dess att det är 60 dagar kvar till ankomst. Vid ombokning till en dyrare period betalas mellanskillnaden av dig, vid ombokning till ett lägre pris återbetalas mellanskillnaden till dig. Du behöver inte ange någon orsak eller lämna något intyg. Ombokning är ej möjlig när det är 59 dagar kvar eller mindre till ankomst.\r\n\r\nDu kan avboka fram till dagen före ankomst med om- och avbeställningsskyddet och återfå allt utom en avbokningsavgift på 500 SEK   det erlagda om- och avbeställningsskyddet. Avbeställningsskyddet gäller i följande fall, som inte får ha varit kända när Du bokade,\r\n\r\ndödsfall, sjukdom eller olycksfall av allvarlig art, som drabbat Dig själv, makemaka, sambo, familj eller medresenär, inkallelse till krigsmakten eller civilförsvaret, det inträffar någon allvarlig händelse utanför din kontroll, som Du inte kunde förutse när du boknade och som medför att det inte är rimligt att begära att Du ska stå fast vid din bokning, t.ex. omfattande eldsvåda eller översvämning i Din bostad.\r\n\r\nDu måste kunna styrka ditt förhinder med intyg från t.ex. läkare, myndighet, arbetsgivare eller skyddsbolag. Intyget ska vara oss tillhanda inom 14 dagar från avbokningsdagen" 
        }
    ], 
    "noofchild1": 0, 
    "noofchild2": 0, 
    "noofchild3": 1, 
    "noofchild5": 0, 
    "accommodationImages": [
        "http://static.r360online.se/klappen/images/8d3abf6456c56ba6d05f7d96702e6e7d_org.jpg", 
        "http://static.r360online.se/klappen/images/12a146e8a3e02bad2d9cb2df3994d2c8_org.jpg", 
        "http://static.r360online.se/klappen/images/1d358dc2abad7b1626df5802cf78e4f4_org.jpg", 
        "http://static.r360online.se/klappen/images/5bd61a6bdb1ab7be1f7b54956591c387_org.jpg", 
        "http://static.r360online.se/klappen/images/1862eb832a7af16a9b84b0344c0a2ad5_org.jpg", 
        "http://static.r360online.se/klappen/images/849cde80ad56c974fafb8e6fbcd9bcd7_org.jpg", 
        "http://static.r360online.se/klappen/images/f8b988f98d4a02a9d2a8354d87e684ae_org.jpg"], 
    "qty": 1 
}]